import { Component, computed, input, inject } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-banner-maintenance',
  templateUrl: './banner-maintenance.html',
  styleUrls: ['./banner-maintenance.scss'],
})
export class BannerMaintenanceComponent {
  maintenance = input<boolean>(false);

  private ui = inject(UiService);
  public i18n = inject(I18nService);

  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());
  isDesktop = computed(() => this.ui.IsDesktop());
}
